import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { PageContent, FlexContainer, Title, SubTitle } from '../styles';
export default (function (_ref) {
    var title = _ref.title, subTitle = _ref.subTitle, children = _ref.children;
    return /*#__PURE__*/ _jsxs(PageContent, {
        children: [title && /*#__PURE__*/ _jsx(Title, {
                children: title
            }), subTitle && /*#__PURE__*/ _jsx(SubTitle, {
                children: subTitle
            }), /*#__PURE__*/ _jsx(FlexContainer, {
                w: "100%",
                flexDirection: "column",
                alignItems: "center",
                flexGrow: 1,
                children: children
            })]
    });
});
